import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { changeCurrency, saveTableConfig } from "../../common/actions";
import Draggable from "react-draggable";

export const LanguageSettingsModal = ({ onCancel }) => {
    const [language, setLanguage] = useState("en");
    const [currency, setCurrency] = useState("USD");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        const savedLanguage = localStorage.getItem("ljs-lang") || "en";
        const savedCurrency = localStorage.getItem("currency") || "USD";

        setLanguage(savedLanguage);
        setCurrency(savedCurrency);
    }, []);

    const handleLanguageChange = newLanguage => {
        setLanguage(newLanguage);
    };

    const handleCurrencyChange = newCurrency => {
        setCurrency(newCurrency);
    };

    const handleSubmit = () => {
        setIsSubmitting(true);
        window.Localize.setLanguage(language);
        localStorage.setItem("currency", currency);
        dispatch(changeCurrency(currency));
        setIsSubmitting(false);
        onCancel();
    };

    return (
        <React.Fragment>
            <div
                className="modal modal-region rst-pwd"
                style={{ display: "block" }}
                id="modalId"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <Draggable handle=".draggable" cancel=".not-draggable">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header draggable">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Settings
                                </h5>
                                <button type="button" className="close not-draggable" data-dismiss="modal" aria-label="Close" onClick={onCancel}>
                                    <span aria-hidden="true">
                                        <img src="/img/close.svg" alt="Close" />
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body region-otr build-type-mod">
                                <form autoComplete="off">
                                    <div className="clr-list">
                                        <div className="col-md-12 mb-4 p-0">
                                            <div className="codeOtr">
                                                <h4>Language</h4>
                                                <div className="custom-selecbox">
                                                    <select
                                                        value={language}
                                                        onChange={e => handleLanguageChange(e.target.value)}
                                                        className="custom-selecbox form-control"
                                                    >
                                                        <option value="en">English</option>
                                                        <option value="es-US">Español (Estados Unidos)</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {/* <div className="codeOtr mt-2">
                                                <h4>Currency</h4>
                                                <div className="custom-selecbox">
                                                    <select
                                                        value={currency}
                                                        onChange={e => handleCurrencyChange(e.target.value)}
                                                        className="custom-selecbox form-control"
                                                    >
                                                        <option value="USD">USD</option>
                                                        <option value="EUR">EUR</option>
                                                        <option value="GBP">GBP</option>
                                                    </select>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </form>
                                <div className="col-md-12 text-center btnOtr d-flex p-0">
                                    <button type="button" className="btn btn-secondary btnClr col" onClick={onCancel} data-dismiss="modal">
                                        Cancel
                                    </button>
                                    <button type="button" className="btn btn-primary btnRgion col" onClick={handleSubmit} disabled={isSubmitting}>
                                        Update
                                        {isSubmitting && <span className="spinner-border spinner-border-sm pl-2" role="status"></span>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>
        </React.Fragment>
    );
};
